export default function readHubMessage(
  messages,
  path,
  fallback = '',
  replacements = {},
) {
  const resolved = String(path || '')
    .split('.')
    .filter(Boolean)
    .reduce((current, segment) => current?.[segment], messages?.hub);

  const baseText = resolved == null ? fallback : resolved;

  return String(baseText).replace(/\{\{(.*?)\}\}|\{(.*?)\}/g, (_, a, b) => {
    const key = String(a || b || '').trim();

    return replacements[key] == null ? `{${key}}` : String(replacements[key]);
  });
}
